<t4-header icon="glyphicon-stats">
  </t4-header>
<mat-tab-group dynamicHeight="true">
  <mat-tab label="{{ 'T4.Settings.Page.' + page.Key | translate : page.Key }}" *ngFor="let page of pages">
    <button mat-button color="primary" matTooltip="{{ 'Turbo.Settings.ManageIntegrations.cmdSaveSetting' | translate:'Save Setting'}}" (click)="saveSettings(page)"><mat-icon>save</mat-icon><span>{{ 'Turbo.Settings.ManageIntegrations.cmdSaveSetting' | translate:'Save Setting'}}</span></button>
    <t4-container title="{{ 'T4.Settings.Section.' + section.Key | translate : section.Key }}" *ngFor="let section of page.Sections">
      <div class="row settingRow" *ngFor="let setting of section.Settings">
        <div class="col-3 name">
          <span style="margin-left: 10px;" class="help" matTooltip="{{ 'T4.Settings.Setting.' + setting.Key + '.Description' | translate : setting.Description }}"><mat-icon>help</mat-icon></span>
          <span matTooltip="{{ 'T4.Settings.Setting.' + setting.Key + '.Name' | translate : setting.Name }}">{{ 'T4.Settings.Setting.' + setting.Key + '.Name' | translate : setting.Name }}</span>
        </div>
        <div class="col-6 value">
          <div class="control">

            <!-- Drop down -->
            <mat-form-field appearance="outline" *ngIf="setting.Control == Controls.DropDown" [disabled]="setting.ReadOnly">
              <mat-select [(value)]="setting.Value">
                <mat-option value=""></mat-option>
                <mat-option [value]="val.Name" *ngFor="let val of setting.ValidValues">
                  {{val.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Text box -->
            <mat-form-field appearance="outline" *ngIf="setting.Control == Controls.TextBox">
              <input type="text" matInput [(ngModel)]="setting.Value" [disabled]="setting.ReadOnly" />
            </mat-form-field>

            <!-- Check box -->
            <mat-checkbox class="campaigninfoicon" style="margin-left: 2px;" color="primary" [disabled]="setting.ReadOnly" [(ngModel)]="setting.Value" *ngIf="setting.Control == Controls.Checkbox"></mat-checkbox>
            
          </div>
        </div>
      </div>
    </t4-container>
  </mat-tab>
</mat-tab-group>
